let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jXWlu")).then(() => parcelRequire('amOe8'));